// Paths that real users and games never link to, but that vulnerability
// scanners and bots probe on almost every public site — WordPress, PHP,
// Laravel/Symfony, and common secret-file guesses. Hitting one of these is
// a strong signal of automated scanning rather than a mistyped URL, so each
// is logged via the log_honeypot_hit() RPC (see
// supabase/migrations/20260828220452_honeypot.sql) before rendering the
// same 404 a real unmatched route would show — the visitor sees nothing
// different, but the hit is on record.
//
// Keep this list in sync with the allowlist inside log_honeypot_hit() —
// the RPC silently drops anything not on its own copy of this list, so a
// path added only here would be logged client-side but never actually
// recorded. A change to either needs a new migration, not an edit to the
// existing one (see supabase/README.md).
export const HONEYPOT_PATHS = [
  "/wp-admin",
  "/wp-login.php",
  "/xmlrpc.php",
  "/.env",
  "/.git/config",
  "/phpmyadmin",
  "/administrator",
  "/config.php",
  "/.aws/credentials",
  "/cgi-bin/php",
  "/vendor/phpunit/phpunit/src/Util/PHP/eval-stdin.php",
  "/telescope/requests",
  "/_profiler",
  "/server-status",
  "/actuator/health",
];
